import { Component, CUSTOM_ELEMENTS_SCHEMA, OnDestroy } from "@angular/core";
import {
  DxChartModule,
  DxFunnelModule,
  DxPieChartModule,
  DxTemplateModule,
} from "devextreme-angular";
import { DxiLegendModule } from "devextreme-angular/ui/nested";
import { DevextremesharedmoduleModule } from '../../../../shared/Module/devextremeshared/devextremeshared.module';
import { SharedModule } from 'primeng/api';
import { LanguageService } from '../../../../services/language.service';
import { UIUtils } from "../../../../services/uiutils.service";
import { AppStateManageService } from "../../../../services/app-state-manage.service";
import { FinancialYearUtilsService } from "../../../../services/current-financial-year.service";
import { DashboardFilterService } from "../../../../services/dashboard_filter_dependent_multiselection.service";
import { DashboardFilterStateStorageService } from "../../../../services/dashboard-filter-state-storage.service";
import { TranslateService } from "@ngx-translate/core";
import { FinancialYear } from "../../../../classes/domain/entities/website/financialyear/financialyearmaster";
import { DomainEnums, DrillDownRequestTypes, DrillDownSubTypes, ReportFilterTypes } from "../../../../classes/infrastructure/enums";
import { TransportData } from "../../../../classes/infrastructure/transportdata";
import { Dashboards } from "../../../../classes/domain/entities/website/dashboard/dashboard";
import { PayloadPacketFacade } from "../../../../classes/infrastructure/payloadpacket/payloadpacketfacade";
import { ServerCommunicatorService } from "../../../../services/server-communicator.service";
import { DashboardsFetchRequest } from "../../../../classes/domain/entities/website/dashboard/dashboardfetchrequest";
import { Router } from "@angular/router";
import { HierarchyFilterComponent } from "../../../../shared/components/hierarchy-filter/hierarchy-filter.component";
import { DRILLDOWN_ROUTE_PATH } from "../../../../classes/domain/entities/website/dashboard/dashboarddrilldown/dashboarddrilldowntarget";
import { DRILLDOWN_TYPES_REQUIRING_SUBTYPE } from "../../../../classes/domain/entities/website/dashboard/dashboarddrilldown/dashboarddrilldowncontext.service";


@Component({
  selector: "app-old-dashboard",
  standalone: true,
  imports: [
    SharedModule,
    DevextremesharedmoduleModule,
    DxPieChartModule,
    DxiLegendModule,
    DxChartModule,
    DxFunnelModule,
    DxTemplateModule,
    HierarchyFilterComponent
  ],
  templateUrl: "./old-dashboard.component.html",
  styleUrl: "./old-dashboard.component.scss",
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class OldDashboardComponent implements OnDestroy {
  constructor(
    private uiUtils: UIUtils,
    private appStateManage: AppStateManageService,
    private CustomDate: FinancialYearUtilsService,
    public DashboardFilterService: DashboardFilterService,
    public filterStorage: DashboardFilterStateStorageService,
    public langService: LanguageService,
    private translate: TranslateService,
    private router: Router,
  ) { }

  // SECTION 1 — FILTER BAR STATE 
  YearsList: FinancialYear[] = [];
  CurrentFinancialYear: string = "";
  FinancialYearRef: number = 0;
  financialYearStart!: Date;
  financialYearEnd!: Date;

  FilterList = DomainEnums.ReportFilterTypesListLang(true, "REPORT_PLACEHOLDERS.Select");
  MonthList = DomainEnums.MonthListLang(true, "REPORT_PLACEHOLDERS.SelectMonth");
  QuarterList = DomainEnums.QuarterTypesListLang(true, "REPORT_PLACEHOLDERS.SelectQuarter");
  HalfYearList = DomainEnums.HalfYearListLang(true, "REPORT_PLACEHOLDERS.SelectHalfYear");

  ReportFilterType: number = 0;
  Month: number = 0;
  QuarterlyYearType: number = 0;
  HalfYearType: number = 0;

  IsShowMonth: boolean = false;
  IsShowQuarter: boolean = false;
  IsShowHalfYear: boolean = false;
  IsShowDates: boolean = false;

  isFilterActive = false;

  // Refresh & Stay Detection State
  isRefreshing: boolean = false;
  isDataStale: boolean = false;
  isBannerDismissed: boolean = false;
  isGuideDismissed: boolean = false;
  justUpdated: boolean = false;
  lastUpdatedTime: Date | null = null;
  readonly STALE_TIMEOUT_MS: number = 2 * 60 * 1000; // 2 minutes stay threshold
  private staleStayTimer: any = null;
  private visibilityHandler: any = null;
  private updatedNoticeTimer: any = null;

  // Rural / Urban toggle
  selectedArea: "rural" | "urban" = "rural";
  isUrbanNoData: boolean = false;

  // Top cards row
  totalPopulationCoveredByAsha: number = 0;
  totalPopulationAssignedToAsha: number = 0;
  noOfFamilies: number = 0;
  childrenBelowFiveYears: number = 0;
  membersAboveThirtyYears: number = 0;

  // Family Registration pie chart (card 1)
  familyStatusData: any[] = [
    { Name: "Approved", Value: 13 },
    { Name: "Pending", Value: 2 },
    { Name: "Native", Value: 15 },
    { Name: "Migrated", Value: 2 },
  ];

  get familyStatusTotal(): number {
    return this.familyStatusData.reduce((sum, x) => sum + x.Value, 0);
  }

  getFamilyPercent(value: number): number {
    return this.percentOf(value, this.familyStatusTotal);
  }


  // --- Card 2: ANC — Antenatal Care ----------------------------------------
  ancRegistered: number = 0;
  ancPregnancyDue: number = 0;
  ancHighRisk: number = 0;
  ancLowRisk: number = 0;


  get ancHighRiskPercent(): number {
    return this.percentOf(this.ancHighRisk, this.ancHighRisk + this.ancLowRisk);
  }
  get ancLowRiskPercent(): number {
    return this.percentOf(this.ancLowRisk, this.ancHighRisk + this.ancLowRisk);
  }

  // --- Card 3: PNC — Postnatal Care -----------------------------------------
  pncTotal: number = 0;
  pncNoofPNCRegistered: number = 0;
  pncVisitsDue: number = 0;
  pncReferredMaata: number = 0;
  pncCompleted: number = 0;

  // --- Card 4: HBNC Overview -------------------------------------------------
  hbncTotal: number = 0;         // was 250
  hbncData: any[] = [];

  hbncIconImages: string[] = [
    'assets/dashboard icons/hbncoverviewA.png',
    'assets/dashboard icons/hbncoverviewB.png',
    'assets/dashboard icons/hbncoverviewc.png',
    'assets/dashboard icons/hbncoverviewE.png',
    'assets/dashboard icons/hbncoverviewD.png',
  ];

  // --- Card 5: Eligible Couple Register --------------------------------------
  ecrTotal: number = 0;
  ecrEligibleCouples: number = 0;
  ecrInfertileCouples: number = 0;
  ecrUsingFamilyPlanning: number = 0;
  ecrNotUsing: number = 0;

  // --- Card 6: Birth Register -------------------------------------------------
  birthTotal: number = 0;
  birthMale: number = 0;
  birthFemale: number = 0;
  birthStillBirth: number = 0;

  customizeHbncLabel = (pointInfo: any): string => {
    return pointInfo.value.toString();
  };


  get ecrUsingPercent(): number {
    return this.percentOf(this.ecrUsingFamilyPlanning, this.ecrUsingFamilyPlanning + this.ecrNotUsing);
  }
  get ecrNotUsingPercent(): number {
    return this.percentOf(this.ecrNotUsing, this.ecrUsingFamilyPlanning + this.ecrNotUsing);
  }

  // --- Card 7: Immunization Overview ------------------------------------------
  immunizationTotal: number = 0; // was 250
  immunizationData: any[] = [];

  immunizationIconImages: string[] = [
    'assets/dashboard icons/fullyimmunizedA.png',
    'assets/dashboard icons/fullyimmunizedB.png',
    'assets/dashboard icons/fullyimmunizedC.png'
  ];


  get immunizationTickInterval(): number {
    const maxValue = Math.max(...this.immunizationData.map(d => d.Value));
    if (maxValue <= 100) return 20;
    if (maxValue <= 250) return 50;
    return 100;
  }

  get immunizationAxisMax(): number {
    const maxValue = Math.max(...this.immunizationData.map(d => d.Value));
    const tick = this.immunizationTickInterval;
    return Math.ceil((maxValue * 1.5) / tick) * tick;
  }

  // --- Card 8: Death Register --------------------------------------------------
  deathTotal: number = 0;
  death0To5Years: number = 0;
  deathANC: number = 0;
  death30PlusYears: number = 0;

  // Card 1: Family Registration
  familyColors: string[] = ['#27ae60', '#f39c12', '#b72d5f', '#f4a6c6'];
  familyLabelMap: { [key: string]: string } = {
    Approved: 'मंजूर',
    Pending: 'प्रलंबित',
    Native: 'मूळ रहिवासी',
    Migrated: 'स्थलांतरित',
  };

  // Card 4: HBNC Overview
  hbncColors: string[] = ['#E1578F', '#3fae5c', '#F39C12', '#9b30d9', '#2f6fd6'];
  hbncIconBg: string[] = ['#fbe0ec', '#d9f2df', '#fff3e0', '#f1e0fb', '#e3f2fd'];
  hbncRowBg: string[] = ['#fdf1f5', '#eefbf1', '#fff8ec', '#f8f1fd', '#eef6fd'];
  hbncIcons: string[] = ['🍼', '🏥', '⏱️', '♿', '📅'];
  hbncLabelMap: { [key: string]: { en: string; mr: string } } = {
    TotalBirth: { en: 'Total Birth', mr: 'एकूण जन्म' },
    GovtHospitalBirth: { en: 'Government Hospital Birth', mr: 'शासकीय रूग्णालयातील जन्म' },
    PreMatureBaby: { en: 'Pre Mature Baby', mr: 'अकाल जन्म झालेली बाळे' },
    DisableChildrens: { en: 'Disable Childrens', mr: 'अपंग बालक' },
    HBNCScheduleNotComplete: { en: "Children Who Didn't Complete HBNC Schedule", mr: 'एचबीएनसी वेळापत्रक पूर्ण न केलेली मुले' },
  };

  // Card 7: Immunization Overview
  immunizationColors: string[] = ['#7bd389', '#2eacd5', '#f6c343', '#9b59d0', '#e94e4e'];
  immunizationIcons: string[] = ['🛡️', '🧴', '💉', '🛡️'];
  immunizationIconBg: string[] = ['#d9f2df', '#e3f2fd', '#fff3e0', '#f1e0fb'];
  immunizationRowBg: string[] = ['#eefbf1', '#eef6fd', '#fff8ec', '#f8f1fd'];

  immunizationLabelMap: { [key: string]: string } = {
    'Fully Immunized': 'पूर्ण लसीकरण झालेले',
    '0 Day Dose Completed': '0 दिवस डोस पूर्ण झालेले',
    'Immunization Started But Not Completed': 'लसीकरण सुरू आहे पण पूर्ण नाही',
    'Partially Immunized Children': 'अंशतः लसीकरण झालेले मुले',
  };

  // Card 8: Death Register
  deathColors: string[] = ['#E1578F', '#2f6fd6', '#F39C12', '#3fae5c'];
  deathIconBg: string[] = ['#fbdce9', '#e3f2fd', '#fff3e0', '#d9f2df'];
  deathRowBg: string[] = ['#fdf1f5', '#eef6fd', '#fff8ec', '#eefbf1'];

  // --- Card 9: Pregnancy Loss --------------------------------------------------
  pregnancyLossTotal: number = 0;
  pregnancyLossAbortion: number = 0;
  pregnancyLossMiscarriage: number = 0;

  //  LIFECYCLE
  async ngOnInit() {
    const stored = this.appStateManage.StorageKey.getItem("FinancialYearResponses");
    const financialYearResponses = stored ? JSON.parse(stored) : [];

    if (financialYearResponses.length) {
      this.FinancialYearRef = financialYearResponses[0].financial_year_id;
      this.CurrentFinancialYear = financialYearResponses[0].short_name;
    }

    this.FilterList = DomainEnums.ReportFilterTypesListLang(false).filter(
      (r) => r.Ref !== ReportFilterTypes.Custom,
    );

    await this.FinancialYear(this.CurrentFinancialYear);
    await this.FormulateFinancialYearList();

    const existingStoredState = this.filterStorage.getFilterState();

    if (!existingStoredState?.ReportFilterType) {
      this.ReportFilterType = ReportFilterTypes.Yearly;
      this.filterStorage.setFilterState({
        ...existingStoredState,
        FinancialYearRef: this.FinancialYearRef,
        ReportFilterType: ReportFilterTypes.Yearly,
      });
    }

    if (existingStoredState.state_ids.length === 0) {
      await this.DashboardFilterService.LoadFilterDataUPTOStateLevel();
    }

    await this.applyDashaboardStateOnFilterDropdown();
    this.initVisibilityListener();

    // Refresh translated dropdown labels on language change
    this.translate.onLangChange.subscribe(() => {
      this.FilterList = [...this.FilterList];
      this.MonthList = [...this.MonthList];
      this.QuarterList = [...this.QuarterList];
      this.HalfYearList = [...this.HalfYearList];
    });
  }

  // FILTER BAR METHODS

  FinancialYear = async (FinancialYear: string) => {
    const range = this.CustomDate.getFinancialYearRange(FinancialYear);
    if (range) {
      this.financialYearStart = range.start;
      this.financialYearEnd = range.end;
    }
  };

  FormulateFinancialYearList = async () => {
    let lst = await FinancialYear.FetchEntireList(
      async (errMsg) => await this.uiUtils.showErrorMessage("Error", errMsg),
    );
    this.YearsList = lst;
  };

  applyDashaboardStateOnFilterDropdown = async () => {
    const savedState = this.filterStorage.getFilterState();
    const reportFilterType = savedState?.ReportFilterType ?? ReportFilterTypes.Yearly;

    this.ReportFilterType = reportFilterType;
    this.applyFilterVisibility(reportFilterType);

    if (savedState?.Month) this.Month = savedState.Month;
    if (savedState?.QuarterlyYearType) this.QuarterlyYearType = savedState.QuarterlyYearType;
    if (savedState?.HalfYearType) this.HalfYearType = savedState.HalfYearType;

    await this.FormulateDashboardList();
  };

  applyFilterVisibility(filterType: number) {
    this.IsShowMonth = filterType === ReportFilterTypes.Monthly;
    this.IsShowQuarter = filterType === ReportFilterTypes.Quarterly;
    this.IsShowHalfYear = filterType === ReportFilterTypes.HalfYearly;
    this.IsShowDates = filterType === ReportFilterTypes.Custom;
  }

  async onYearChanged(e: any) {
    const newValue = e.value;
    if (!newValue) return;

    this.FinancialYearRef = newValue;
    this.filterStorage.setFilterState({ FinancialYearRef: this.FinancialYearRef });

    const selectedYear = this.YearsList.find((y) => y.p.id === newValue);
    if (!selectedYear) return;

    this.CurrentFinancialYear = selectedYear.p.short_name;

    if ((this.FinancialYearRef && e.previousValue == 0) || e.previousValue == null) return;

    await this.FormulateDashboardList();
  }

  OnFilterChange = async (FilterRef: number) => {
    if (FilterRef == 0) return;

    this.ReportFilterType = FilterRef;
    this.Month = 0;
    this.QuarterlyYearType = 0;
    this.HalfYearType = 0;

    this.applyFilterVisibility(FilterRef);

    this.filterStorage.setFilterState({ ReportFilterType: FilterRef });

    if (FilterRef === ReportFilterTypes.Yearly) {
      await this.FormulateDashboardList();
    }
  };

  onMonthChanged = async (e: any) => {
    if (!e.value) return;
    this.Month = e.value;
    this.filterStorage.setFilterState({ Month: this.Month });
    await this.FormulateDashboardList();
  };

  onQuarterChanged = async (e: any) => {
    if (!e.value) return;
    this.QuarterlyYearType = e.value;
    this.filterStorage.setFilterState({ QuarterlyYearType: this.QuarterlyYearType });
    await this.FormulateDashboardList();
  };

  onHalfYearChanged = async (e: any) => {
    if (!e.value) return;
    this.HalfYearType = e.value;
    this.filterStorage.setFilterState({ HalfYearType: this.HalfYearType });
    await this.FormulateDashboardList();
  };

  async toggleFilterPopup() {
    this.isFilterActive = !this.isFilterActive;
    await this.DashboardFilterService.LoadFilterDataUPTOStateLevel();
  }

  applyFilters = async () => {
    this.isFilterActive = false;
    this.filterStorage.setFilterState({
      FinancialYearRef: this.FinancialYearRef,
      ReportFilterType: this.ReportFilterType,
      Month: this.Month,
      QuarterlyYearType: this.QuarterlyYearType,
      HalfYearType: this.HalfYearType,
      state_ids: this.DashboardFilterService.state_ids,
      zone_ids: this.DashboardFilterService.zone_ids,
      district_ids: this.DashboardFilterService.district_ids,
      block_ids: this.DashboardFilterService.block_ids,
      bcm_post_ids: this.DashboardFilterService.bcm_post_ids,
      phc_ids: this.DashboardFilterService.phc_ids,
      af_ids: this.DashboardFilterService.af_ids,
      sc_ids: this.DashboardFilterService.sc_ids,
      village_ids: this.DashboardFilterService.village_ids,
      asha_ids: this.DashboardFilterService.asha_ids,
      // Drill-down requests use this field, so preserve the dashboard ASHA
      // selection under the same name expected by the destination page.
      asha_employee_record_ids: this.DashboardFilterService.asha_ids,
    });
    await this.FormulateDashboardList();
  };

  async clearFilters() {
    this.DashboardFilterService.block_ids = [];
    this.DashboardFilterService.bcm_post_ids = [];
    this.DashboardFilterService.phc_ids = [];
    this.DashboardFilterService.af_ids = [];
    this.DashboardFilterService.sc_ids = [];
    this.DashboardFilterService.village_ids = [];
    this.DashboardFilterService.asha_ids = [];
    this.isFilterActive = false;
  }

  onAreaChange(area: "rural" | "urban") {
    if (this.selectedArea === area) return;
    this.selectedArea = area;

    if (area === "urban") {
      this.isUrbanNoData = true;
      this.resetDashboardData();
      return;
    }
    this.isUrbanNoData = false;
    this.FormulateDashboardList();
  }

  resetDashboardData() {
    this.totalPopulationCoveredByAsha = 0;
    this.totalPopulationAssignedToAsha = 0;
    this.noOfFamilies = 0;
    this.childrenBelowFiveYears = 0;
    this.membersAboveThirtyYears = 0;
    this.familyStatusData = [];
  }

  getTranslatedName = (item: any): string => (item ? this.translate.instant(item.Name) : "");

  // Fetch Request and Formulate Dashboard List 
  FormulateDashboardList = async () => {
    let req = new DashboardsFetchRequest();

    if (this.FinancialYearRef) req.financial_year_ids.push(this.FinancialYearRef);
    if (this.ReportFilterType) req.report_filter_type = this.ReportFilterType;
    if (this.Month) req.month = this.Month;
    if (this.QuarterlyYearType) req.quarterly_year_type = this.QuarterlyYearType;
    if (this.HalfYearType) req.half_year_type = this.HalfYearType;

    if (this.DashboardFilterService.state_ids.length > 0) req.state_ids = this.DashboardFilterService.state_ids;
    if (this.DashboardFilterService.zone_ids.length > 0) req.zone_ids = this.DashboardFilterService.zone_ids;
    if (this.DashboardFilterService.district_ids.length > 0) req.district_ids = this.DashboardFilterService.district_ids;
    if (this.DashboardFilterService.block_ids.length > 0) req.block_ids = this.DashboardFilterService.block_ids;
    if (this.DashboardFilterService.phc_ids.length > 0) req.phc_ids = this.DashboardFilterService.phc_ids;
    if (this.DashboardFilterService.sc_ids.length > 0) req.sc_ids = this.DashboardFilterService.sc_ids;
    if (this.DashboardFilterService.bcm_post_ids.length > 0) req.bcm_post_ids = this.DashboardFilterService.bcm_post_ids;
    if (this.DashboardFilterService.village_ids.length > 0) req.village_ids = this.DashboardFilterService.village_ids;
    if (this.DashboardFilterService.asha_ids.length > 0) req.asha_employee_record_ids = this.DashboardFilterService.asha_ids;

    let pktRequest = PayloadPacketFacade.GetInstance().CreateNewPayloadPacket2(req.FormulateTransportData());
    let tr = await ServerCommunicatorService.GetInstance().sendHttpRequestWithoutLoader(pktRequest);

    if (!tr.Successful) {
      await this.uiUtils.showInformationalMessage("Error", tr.Message);
      return;
    }

    const tdResponse = JSON.parse(tr.Tag) as TransportData;
    const res = Dashboards.FromTransportData(tdResponse);
    if (!res || res.length === 0) return;

    const data = res[0];
    const kf = data.key_figures;
    const ov = data.overview;

    console.log("[Dashboard] raw API record:", data);

    // --- Key figures (top cards) ---
    this.animateCounter("totalPopulationCoveredByAsha", Number(kf?.total_population_covered_by_asha) || 0);
    this.animateCounter("totalPopulationAssignedToAsha", Number(kf?.total_population_assigned_to_asha) || 0);
    this.animateCounter("noOfFamilies", Number(kf?.no_of_families) || 0);
    this.animateCounter("childrenBelowFiveYears", Number(kf?.no_of_children_from_zero_to_six_years) || 0);
    this.animateCounter("membersAboveThirtyYears", Number(kf?.no_of_members_above_thirty_years) || 0);

    // --- ANC ---
    this.ancRegistered = Number(ov?.total_anc) || 0;
    this.ancPregnancyDue = Number(ov?.expected_deliveries) || 0;
    this.ancHighRisk = Number(ov?.high_risk_maata) || 0;
    this.ancLowRisk = Number(ov?.normal_maata) || 0;

    // --- Family status pie ---
    this.familyStatusData = [
      { Name: "Approved", Value: Number(ov?.approved_families) || 0 },
      { Name: "Pending", Value: Number(ov?.pending_families) || 0 },
      { Name: "Native", Value: Number(ov?.native_families) || 0 },
      { Name: "Migrated", Value: Number(ov?.migrated_families) || 0 },
    ];

    // --- PNC ---
    this.pncTotal = Number(ov?.total_pnc) || 0;
    this.pncNoofPNCRegistered = Number(ov?.total_pnc) || 0;
    this.pncReferredMaata = Number(ov?.high_risk_pnc) || 0;
    this.pncCompleted = Number(ov?.total_pnc_visits_completed) || 0;
    this.pncVisitsDue = Math.max(0, this.pncTotal - this.pncReferredMaata - this.pncCompleted);

    // --- HBNC ---
    // The new response has no govt_hospital_birth, pre_mature_baby or
    // baby_visits_not_complete fields, so those rows show 0 for now.
    this.hbncTotal = Number(ov?.total_hbnc) || 0;
    this.hbncData = [
      { Name: "TotalBirth", Value: Number(ov?.total_hbnc) || 0 },
      { Name: "GovtHospitalBirth", Value: 0 },
      { Name: "PreMatureBaby", Value: 0 },
      { Name: "DisableChildrens", Value: Number(ov?.defective_children) || 0 },
      { Name: "HBNCScheduleNotComplete", Value: Number(ov?.zero_visits_completed) || 0 },
    ];

    // --- Eligible couple ---
    this.ecrTotal = Number(ov?.total_eligible_couple) || 0;
    this.ecrEligibleCouples = Number(ov?.total_eligible_couple) || 0;
    this.ecrInfertileCouples = Number(ov?.infertile_couple) || 0;
    this.ecrUsingFamilyPlanning = Number(ov?.family_planning_used) || 0;
    // No "not used" field in the new response, so derive it.
    this.ecrNotUsing = Math.max(0, this.ecrEligibleCouples - this.ecrUsingFamilyPlanning);

    // --- Birth ---
    this.birthTotal = Number(ov?.total_birth) || 0;
    this.birthStillBirth = Number(ov?.still_birth) || 0;
    this.birthMale = Number(ov?.total_male_birth) || 0;
    this.birthFemale = Number(ov?.total_female_birth) || 0;

    // --- Death ---
    this.deathTotal = Number(ov?.total_death) || 0;
    this.death0To5Years = Number(ov?.zero_to_five_years_death) || 0;
    this.deathANC = Number(ov?.anc_death) || 0;
    this.death30PlusYears = Number(ov?.thirty_above_death) || 0;

    // --- Immunization ---
    const fullyImmunized = Number(ov?.fully_immunized_children) || 0;
    const zeroDoseCompleted = Number(ov?.children_with_no_vaccination) || 0;
    const startedNotComplete = Number(ov?.children_with_incomplete_immunization) || 0;

    this.immunizationData = [
      { Name: "Fully Immunized", Value: fullyImmunized },
      { Name: "0 Day Dose Completed", Value: zeroDoseCompleted },
      { Name: "Immunization Started But Not Completed", Value: startedNotComplete },
    ];
    this.immunizationTotal = fullyImmunized + zeroDoseCompleted + startedNotComplete;

    // --- Pregnancy loss ---
    this.pregnancyLossAbortion = Number(ov?.abortion) || 0;
    this.pregnancyLossMiscarriage = Number(ov?.miscarriage) || 0;
    this.pregnancyLossTotal = Number(ov?.total_pregnancy_loss)
      || (this.pregnancyLossAbortion + this.pregnancyLossMiscarriage);

    this.lastUpdatedTime = new Date();
    this.resetStayTimer();
  };

  animateCounter(id: string, end: number, duration: number = 1500) {
    const obj = document.getElementById(id);
    if (!obj) return;
    const start = parseInt(obj.innerText.replace(/[^0-9]/g, "")) || 0;
    const range = end - start;
    const fps = 60;
    const steps = Math.ceil(duration / (1000 / fps));
    let currentStep = 0;
    const timer = setInterval(() => {
      currentStep++;
      const progress = 1 - Math.pow(1 - currentStep / steps, 3);
      obj.innerText = Math.floor(start + range * progress).toLocaleString("en-IN");
      if (currentStep >= steps) {
        clearInterval(timer);
        obj.innerText = end.toLocaleString("en-IN");
      }
    }, 1000 / fps);
  }

  //  NAVIGATION start ==================================================================================
  private percentOf(part: number, total: number): number {
    if (!total) return 0;
    return Math.round((part / total) * 100);
  }

  customizeTooltip = (arg: any) => {
    if (arg.percent !== undefined && !isNaN(arg.percent)) {
      const percent = (arg.percent * 100).toFixed(1);
      return {
        text: `${arg.argumentText}: ${arg.valueText} (${percent}%)`,
      };
    }
    return {
      text: `${arg.argumentText}: ${arg.valueText}`,
    };
  };

  customizeImmunizationPoint = (pointInfo: any) => {
    const idx = this.immunizationData.findIndex((d) => d.Name === pointInfo.argument);
    return { color: this.immunizationColors[idx] };
  };

  private navigateToDrillDown = async (
    requestType: DrillDownRequestTypes,
    subType: DrillDownSubTypes = DrillDownSubTypes.none,
  ) => {
    const requiresSubType = DRILLDOWN_TYPES_REQUIRING_SUBTYPE.includes(requestType);

    if (requiresSubType && subType === DrillDownSubTypes.none) {
      console.error(
        `[Dashboard] "${DrillDownRequestTypes[requestType]}" requires a drillDownSubType but none was passed.`
      );
      return;
    }

    this.filterStorage.setDrillDownContext(requestType, subType);
    await this.router.navigate([DRILLDOWN_ROUTE_PATH]);
  };

  // No sub-type — whole card, single value
  getFamiliesList = async () => {
    await this.navigateToDrillDown(DrillDownRequestTypes.total_population_covered_by_asha);
  };

  getTotalAssignedFamiliesClick = async () => {
    // total_population_assigned_to_asha no longer exists in DrillDownRequestTypes,
    // so this card opens the covered-by-ASHA list.
    await this.navigateToDrillDown(DrillDownRequestTypes.total_population_covered_by_asha);
  };

  getNooffamilies = async () => {
    await this.navigateToDrillDown(DrillDownRequestTypes.no_of_familes);
  };

  get0to5yearchild = async () => {
    await this.navigateToDrillDown(DrillDownRequestTypes.children_0_to_6_yeras);
  };

  getmemberabove30 = async () => {
    await this.navigateToDrillDown(DrillDownRequestTypes.member_above_30_years);
  };

  // Has a segment — pass sub-type explicitly
  // Segments with no matching sub-type in the new enum are left undefined and do nothing on click.
  onFamilyStatusClick = async (item: { Name: string; Value: number }) => {
    const subType = this.familyStatusTargetMap[item.Name];
    if (subType === undefined) return;
    await this.navigateToDrillDown(DrillDownRequestTypes.family_registration, subType);
  };

  onFamilyPieClick = async (e: any) => {
    const name = e?.target?.argument;
    if (!name) return;
    await this.onFamilyStatusClick({ Name: name, Value: e.target.value });
  };

  familyStatusTargetMap: { [key: string]: DrillDownSubTypes | undefined } = {
    Approved: DrillDownSubTypes.family_registration_approved,
    Pending: DrillDownSubTypes.family_registration_pending,
    // Native / Migrated: the new enum only has approved_native, approved_migrated,
    // pending_native and pending_migrated, so there is no overall Native or Migrated drill-down.
    Native: undefined,
    Migrated: undefined,
  };

  onAncStatClick = async (segment: "registered" | "pregnancydue" | "highRisk" | "normal") => {
    const map: Record<string, DrillDownSubTypes> = {
      registered: DrillDownSubTypes.anc_total,
      pregnancydue: DrillDownSubTypes.anc_expected_deliveries,
      highRisk: DrillDownSubTypes.anc_high_risk_maata,
      normal: DrillDownSubTypes.anc_normal_maata,
    };
    await this.navigateToDrillDown(DrillDownRequestTypes.anc, map[segment]);
  };

  // --- PNC — Postnatal Care ---------------------------------------------
  pncTargetMap: { [key: string]: DrillDownSubTypes | undefined } = {
    NoofPNCRegistered: DrillDownSubTypes.pnc_total,
    visitsDue: undefined, // no matching sub-type in the new enum
    referredMaata: DrillDownSubTypes.pnc_high_risk_pnc, // closest match — confirm with backend
    completed: DrillDownSubTypes.pnc_total_pnc_visits_completed,
  };

  onPncStatClick = async (segment: "NoofPNCRegistered" | "visitsDue" | "referredMaata" | "completed") => {
    const subType = this.pncTargetMap[segment];
    if (subType === undefined) return;
    await this.navigateToDrillDown(DrillDownRequestTypes.pnc, subType);
  };

  // --- HBNC Overview -------------------------------------------------------
  hbncTargetMap: { [key: string]: DrillDownSubTypes | undefined } = {
    TotalBirth: DrillDownSubTypes.hbnc_total_birth,
    GovtHospitalBirth: undefined, // no matching sub-type in the new enum
    PreMatureBaby: undefined, // no matching sub-type in the new enum
    DisableChildrens: DrillDownSubTypes.hbnc_defective_children,
    HBNCScheduleNotComplete: undefined, // no matching sub-type in the new enum
  };

  onHbncItemClick = async (item: { Name: string; Value: number }) => {
    const subType = this.hbncTargetMap[item.Name];
    if (subType === undefined) return;
    await this.navigateToDrillDown(DrillDownRequestTypes.hbnc, subType);
  };

  // --- Eligible Couple Register --------------------------------------------
  ecrTargetMap: { [key: string]: DrillDownSubTypes | undefined } = {
    eligible: DrillDownSubTypes.eligible_couple_register_eligible_couples_total,
    infertile: DrillDownSubTypes.eligible_couple_register_infertile,
    using: DrillDownSubTypes.eligible_couple_register_family_planning_usage,
    notUsing: undefined, // no matching sub-type in the new enum
  };

  onEcrStatClick = async (segment: "eligible" | "infertile" | "using" | "notUsing") => {
    const subType = this.ecrTargetMap[segment];
    if (subType === undefined) return;
    await this.navigateToDrillDown(DrillDownRequestTypes.eligible_couple_register, subType);
  };

  // --- Birth Register -------------------------------------------------------
  birthTargetMap: { [key: string]: DrillDownSubTypes | undefined } = {
    total: DrillDownSubTypes.birth_total,
    still: undefined, // no still-birth sub-type under birth_register (still birth is under death_register now)
    male: DrillDownSubTypes.birth_boy,
    female: DrillDownSubTypes.birth_girl,
  };

  onBirthStatClick = async (segment: "total" | "still" | "male" | "female") => {
    const subType = this.birthTargetMap[segment];
    if (subType === undefined) return;
    await this.navigateToDrillDown(DrillDownRequestTypes.birth_register, subType);
  };

  // --- Death Register --------------------------------------------------------
  onDeathStatClick = async (segment: "total" | "0to5" | "anc" | "30plus") => {
    const map: Record<string, DrillDownSubTypes> = {
      total: DrillDownSubTypes.death_total,
      "0to5": DrillDownSubTypes.death_0_to_5_years_death,
      anc: DrillDownSubTypes.death_anc_death,
      "30plus": DrillDownSubTypes.death_above_30_years_death,
    };
    await this.navigateToDrillDown(DrillDownRequestTypes.death_register, map[segment]);
  };

  // --- Immunization Overview -------------------------------------------------
  immunizationTargetMap: { [key: string]: DrillDownSubTypes } = {
    'Fully Immunized': DrillDownSubTypes.immunization_fully,
    '0 Day Dose Completed': DrillDownSubTypes.immunization_zero_dose,
    'Immunization Started But Not Completed': DrillDownSubTypes.immunization_started_not_completed,
    'Partially Immunized Children': DrillDownSubTypes.immunization_partial,
  };

  onImmunizationItemClick = async (item: { Name: string; Value: number }) => {
    const subType = this.immunizationTargetMap[item.Name];
    if (subType === undefined) return;
    await this.navigateToDrillDown(DrillDownRequestTypes.child_immunization, subType);
  };

  onImmunizationBarClick = async (e: any) => {
    const name = e?.target?.argument;
    if (!name) return;
    await this.onImmunizationItemClick({ Name: name, Value: e.target.value });
  };

  // --- Pregnancy Loss ------------------------------------------------------
  onPregnancyLossStatClick = async (segment: "abortion" | "miscarriage") => {
    const map: Record<string, DrillDownSubTypes> = {
      abortion: DrillDownSubTypes.pregnancy_loss_abortion,
      miscarriage: DrillDownSubTypes.pregnancy_loss_miscarriage,
    };
    await this.navigateToDrillDown(DrillDownRequestTypes.pregnancy_loss, map[segment]);
  };

  // Navigation End ==============================================================================

  // For Filter Popup — opens instantly, then loads cascade data (loader shows inside popup)
  async openFilterPanel(): Promise<void> {
    this.DashboardFilterService.openFilter();
    await this.DashboardFilterService.LoadFilterDataUPTOStateLevel();
  }

  // Called by <app-hierarchy-filter (applied)="..."> after user hits Apply
  onFiltersApplied = async () => {
    this.filterStorage.setFilterState({
      FinancialYearRef: this.FinancialYearRef,
      ReportFilterType: this.ReportFilterType,
      Month: this.Month,
      QuarterlyYearType: this.QuarterlyYearType,
      HalfYearType: this.HalfYearType,
      state_ids: this.DashboardFilterService.state_ids,
      zone_ids: this.DashboardFilterService.zone_ids,
      district_ids: this.DashboardFilterService.district_ids,
      block_ids: this.DashboardFilterService.block_ids,
      bcm_post_ids: this.DashboardFilterService.bcm_post_ids,
      phc_ids: this.DashboardFilterService.phc_ids,
      af_ids: this.DashboardFilterService.af_ids,
      sc_ids: this.DashboardFilterService.sc_ids,
      village_ids: this.DashboardFilterService.village_ids,
      asha_ids: this.DashboardFilterService.asha_ids,
      asha_employee_record_ids: this.DashboardFilterService.asha_ids,
    });
    await this.FormulateDashboardList();
  };

  // Called after user hits Clear — service state is already reset by then
  onFiltersCleared = () => {
    // add any dashboard-specific reset here if needed (e.g. refetch with cleared filters)
  };

  // --- REFRESH & STAY DETECTION METHODS ---

  // Start or reset stay timer
  startStayTimer(): void {
    this.clearStayTimer();
    this.staleStayTimer = setTimeout(() => {
      this.isDataStale = true;
      this.isBannerDismissed = false;
      this.isGuideDismissed = false;
    }, this.STALE_TIMEOUT_MS);
  }

  clearStayTimer(): void {
    if (this.staleStayTimer) {
      clearTimeout(this.staleStayTimer);
      this.staleStayTimer = null;
    }
  }

  resetStayTimer(): void {
    this.startStayTimer();
  }

  // Detect when user tab becomes visible after being away for more than threshold
  initVisibilityListener(): void {
    this.visibilityHandler = () => {
      if (document.visibilityState === "visible") {
        if (this.lastUpdatedTime) {
          const elapsed = Date.now() - this.lastUpdatedTime.getTime();
          if (elapsed >= this.STALE_TIMEOUT_MS) {
            this.isDataStale = true;
            this.isBannerDismissed = false;
            this.isGuideDismissed = false;
          }
        }
      }
    };
    document.addEventListener("visibilitychange", this.visibilityHandler);
  }

  // Dismiss banner manually; refresh button remains highlighted
  dismissStaleBanner(): void {
    this.isBannerDismissed = true;
  }

  // Dismiss user guide pointer directly
  dismissGuide(event?: MouseEvent): void {
    if (event) {
      event.stopPropagation();
    }
    this.isGuideDismissed = true;
  }

  // Formatted last updated time string
  getFormattedLastUpdated(): string {
    if (!this.lastUpdatedTime) return "";
    return this.lastUpdatedTime.toLocaleTimeString([], {
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
    });
  }

  // User triggers manual refresh
  refreshDashboard = async (): Promise<void> => {
    if (this.isRefreshing) return;
    this.isRefreshing = true;
    try {
      await this.FormulateDashboardList();
      this.isDataStale = false;
      this.isBannerDismissed = false;
      this.isGuideDismissed = false;
      this.justUpdated = true;

      if (this.updatedNoticeTimer) clearTimeout(this.updatedNoticeTimer);
      this.updatedNoticeTimer = setTimeout(() => {
        this.justUpdated = false;
      }, 3000);
    } catch (err) {
      console.error("[Dashboard] Error refreshing dashboard data:", err);
    } finally {
      this.isRefreshing = false;
    }
  };

  ngOnDestroy(): void {
    this.clearStayTimer();
    if (this.updatedNoticeTimer) {
      clearTimeout(this.updatedNoticeTimer);
      this.updatedNoticeTimer = null;
    }
    if (this.visibilityHandler) {
      document.removeEventListener("visibilitychange", this.visibilityHandler);
      this.visibilityHandler = null;
    }
  }
}